<template>
  <form @submit="onSubmit" class="container container--xxxxs authenticationForm">

    <!-- Email -->
    <FormInput
        :label="translation('global_input-email-label')"
        :required="true"
        :type="'email'"
        :placeholder="translation('global_input-email-placeholder')"
        :uuid="`email`"
        :error="emailError"
        v-model="email"
    >
      <template v-slot:icon>
        <img
            src="../assets/images/icons/envelope.svg"
            alt=""
            class="icon"
            width="23"
            height="18"
            loading="lazy"
        >
      </template>
    </FormInput>

    <!-- Button -->
    <BaseButton
        type="submit"
        class="mt-1"
        :full-width="true"
        :isDisabled="isSubmitting"
    >
      {{ translation('forgot_form-submit_button') }}
    </BaseButton>
  </form>
</template>

<script>
import BaseAlertList from "@/components/BaseAlertList";
import BaseButton from "@/components/BaseButton";
import FormInput from "@/components/FormInput";
import {codeBooksHelpers} from "@/helpers/codeBooks.helper";
import {authenticationService} from "@/services/authentication";
import {useField, useForm} from 'vee-validate';
import {useStore} from "vuex";
import * as yup from 'yup';

export default {
  components: {
    FormInput,
    BaseButton,
    BaseAlertList
  },
  setup() {
    // import translations
    const {translation} = codeBooksHelpers()

    // get store
    const store = useStore()

    // validator config
    const validationSchema = yup.object({
      email: yup
          .string()
          .required(() => translation('global_input-email-error'))
          .email(() => translation('global_validation-email_format'))
    })

    // Creates a vee-validate form context
    const {handleSubmit, isSubmitting} = useForm({
      validationSchema
    });

    // create a form fields with its validation state
    const {value: email, errorMessage: emailError} = useField('email')

    // submit handler
    const onSubmit = handleSubmit(async values => {

      try {
        // Send data to the API
        await authenticationService.forgotPassword(values.email)
      } catch (err) {
      } finally {

        // Show success every time
        store.dispatch("app/addAlertMessage", {message: translation('forgot_form-alert-success'), type: "success"})

        // redirect
        location.href = '/login';
      }
    });

    return {
      email,
      emailError,
      onSubmit,
      isSubmitting,
      translation,
    };
  }
}
</script>